import { render } from "./sign_up.vue?vue&type=template&id=5716fde1&scoped=true"
import script from "./sign_up.vue?vue&type=script&lang=js"
export * from "./sign_up.vue?vue&type=script&lang=js"

import "./sign_up.vue?vue&type=style&index=0&id=5716fde1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\holo\\work\\git-all-source,\\stress_check_Rebuild\\source\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5716fde1"]])

export default __exports__